module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h1",
    attrs: {
      "id": "toc"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v("Contents"), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("HarperCollins e-book exclusive extras:"), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "RWTOC-7"
    }
  }), _c('a', {
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "href": "#/xhtml/fm1#_RWTOC-7"
    }
  }, [_vm._v("Hero of the Humdrum")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "RWTOC-8"
    }
  }), _c('a', {
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "href": "#/xhtml/fm2#_RWTOC-8"
    }
  }, [_vm._v("The Giller Prize")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "RWTOC-9"
    }
  }), _c('a', {
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "href": "#/xhtml/fm3#_RWTOC-9"
    }
  }, [_vm._v("Governor General’s Awards")]), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "epi"
    }
  }), _c('a', {
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "href": "#/xhtml/epi#epi"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "RWTOC-1"
    }
  }), _c('a', {
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "href": "#/xhtml/chapter1#_RWTOC-1"
    }
  }, [_vm._v("1934")]), _vm._v("   Nora left for New York City today.")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "RWTOC-2"
    }
  }), _c('a', {
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "href": "#/xhtml/chapter2#_RWTOC-2"
    }
  }, [_vm._v("1935")]), _vm._v("   Thank you for the brooch.")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "RWTOC-3"
    }
  }), _c('span', {
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "href": "#/xhtml/chapter3#_RWTOC-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1936")]), _vm._v("   Happy New Year!!!")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "RWTOC-4"
    }
  }), _c('span', {
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "href": "#/xhtml/chapter4#_RWTOC-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1937")]), _vm._v("   A blustery day and I spent a good part of the afternoon visiting. . .")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "RWTOC-5"
    }
  }), _c('span', {
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "href": "#/xhtml/chapter5#_RWTOC-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1938")]), _vm._v("   Awakened in the night by the wind and this morning I looked out. . .")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "RWTOC-6"
    }
  }), _c('span', {
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "href": "#/xhtml/bm#_RWTOC-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "ata-1"
    }
  }), _c('span', {
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "href": "#/xhtml/ata#ata",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "adc-1"
    }
  }), _c('span', {
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "href": "#/xhtml/adc#also",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also by Richard B. Wright")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "cre-1"
    }
  }), _c('span', {
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "href": "#/xhtml/cre#cred",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Credits")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "cop-1"
    }
  }), _c('span', {
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "href": "#/xhtml/cop#copy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "atp-1"
    }
  }), _c('span', {
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "href": "#/xhtml/atp#atp",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Publisher")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56dbfe46","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/content.vue
// module id = 69
// module chunks = 0